class TestResult {
  /**
   * @param data
   */
  constructor (data) {
    const properties = [
      'id',
      'value',
      'clientId',
      'testId',
      'testName',
      'testMeasure',
      'categoryId',
      'categoryName'
    ];

    for (const property of properties) {
      if (typeof data[property] !== 'string') {
        throw new Error(`Invalid property ${property}: ${data[property]}`);
      }

      this[property] = data[property];
    }

    for (const property of ['testSort', 'categorySort']) {
      if (typeof data[property] !== 'number') {
        throw new Error(`Invalid property ${property}: ${data[property]}`);
      }

      this[property] = data[property];
    }

    this.date = new Date(data.date);

    if (typeof data.testReference !== 'object') {
      throw new Error(`Invalid property testReference: ${data.testReference}`);
    }

    this.testHealthId = typeof data.testHealthId === 'string' ? data.testHealthId : null;
    this.testReference = {};
    this.status = '';

    const value = Number(this.value);

    for (const type of ['deviation', 'normal']) {
      if (typeof data.testReference[type] !== 'string') {
        this.testReference[type] = '';

        continue;
      }

      this.status = this.status === '' ? 'disease' : this.status;
      this.testReference[type] = data.testReference[type];

      const regexp = /^([0-9]+\.?[0-9]?)-([0-9]+\.?[0-9]?)$/;
      const range = this.testReference[type].match(regexp);

      if (range !== null) {
        const [, min, max] = range;

        if (value >= Number(min) && value <= Number(max)) {
          this.status = type;
        }
      } else  if (this.value === this.testReference[type]) {
        this.status = type;
      }
    }
  }
}

export default TestResult;
